export const environment = {
  production: false,
  showStagingWatermark: true,
  apiDomain: 'argo.ml3ds-rt-cloud.com',
  productDataPath: 'https://productdatart.blob.core.windows.net/productdata',
  buildNumber: '570',
  useServiceWorker: true,
  useUseBerry: false
};
